export enum DigitalServiceTypes {
  siguranNet='sigurannet',
  apollon='apollon',
  arenaCloud='arenacloud',
  balkanMusic='balkan',
  deezer='deezer',
  nba='nba',
}
